module.exports = __webpack_public_path__ + "static/media/handshake.a944a4e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/handshake.svg
// module id = 280
// module chunks = 0